import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BonoPacienteEstaticoBody, BonoPacienteDinamicoBody } from 'src/app/shared/servicio/bonusqr/bonusqr.service';

@Component({
  selector: 'app-bono-form',
  templateUrl: './bono-form.component.html',
  styleUrls: ['./bono-form.component.css'],
})
export class BonoFormComponent implements OnChanges {
  // 'static' -> /public/qr/{code}/redeem/ (pide cc_type, country_code, specialty_id, email)
  // 'dynamic' -> /public/dynamic-qr/{token}/redeem/ (pide cc, first_name, last_name, cell,
  //              specialty_id, email; cc_type y country_code van implícitos con su valor por defecto)
  @Input() mode: 'static' | 'dynamic' = 'static';
  @Input() specialties: { id: number; name: string }[] = [];
  @Input() disabled = false;
  @Input() submitting = false;
  @Output() formSubmit = new EventEmitter<BonoPacienteEstaticoBody | BonoPacienteDinamicoBody>();

  form: FormGroup;
  submitted = false;

  constructor(private _fb: FormBuilder) {
    this.form = this._fb.group({
      cc: ['', Validators.required],
      first_name: ['', Validators.required],
      last_name: ['', Validators.required],
      cell: ['', Validators.required],
      cc_type: [0],
      country_code: ['57'],
      specialty_id: [null],
      email: [''],
    });
  }

  get f() {
    return this.form.controls;
  }

  get isStatic(): boolean {
    return this.mode !== 'dynamic';
  }

  ngOnChanges(): void {
    if (this.disabled) {
      this.form.disable();
    } else {
      this.form.enable();
    }

    const staticControls = ['cc_type', 'country_code'];
    staticControls.forEach((name) => {
      const control = this.form.get(name);
      if (this.isStatic) {
        control.setValidators(Validators.required);
      } else {
        control.clearValidators();
      }
      control.updateValueAndValidity({ emitEvent: false });
    });

    // specialty_id se pide en ambos modos (estático y dinámico)
    const specialtyControl = this.form.get('specialty_id');
    specialtyControl.setValidators(Validators.required);
    specialtyControl.updateValueAndValidity({ emitEvent: false });
  }

  submit(): void {
    this.submitted = true;
    if (this.form.invalid) {
      return;
    }

    const raw = this.form.value;

    if (this.isStatic) {
      const body: BonoPacienteEstaticoBody = {
        cc_type: Number(raw.cc_type),
        cc: raw.cc,
        first_name: raw.first_name,
        last_name: raw.last_name,
        country_code: raw.country_code,
        cell: raw.cell,
        specialty_id: String(raw.specialty_id),
        email: raw.email,
      };
      this.formSubmit.emit(body);
    } else {
      const body: BonoPacienteDinamicoBody = {
        cc_type: Number(raw.cc_type),
        cc: raw.cc,
        first_name: raw.first_name,
        last_name: raw.last_name,
        country_code: raw.country_code,
        cell: raw.cell,
        specialty_id: String(raw.specialty_id),
        email: raw.email,
      };
      this.formSubmit.emit(body);
    }
  }
}
